"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (props) {
    return _react2.default.createElement(
        "svg",
        { width: "28", height: "30", viewBox: "0 0 28 30", className: "Icon element-column", xmlns: "http://www.w3.org/2000/svg" },
        _react2.default.createElement(
            "g",
            { fill: "none", fillRule: "evenodd" },
            _react2.default.createElement("path", { fill: "#FFF", d: "M1 1h26v28H1z" }),
            _react2.default.createElement("path", { d: "M28 29l-1 1v-1h1zM1 29h26V1H1v28zM0 0h28v30H0V0z", fill: "#A5A5A5" }),
            _react2.default.createElement("path", { d: "M24 25h1l-1 1v-1zM4 25h20v-6H4v6zm-1-7h22v8H3v-8zM24 16h1l-1 1v-1zM4 16h20v-6H4v6zM3 9h22v8H3V9z", fill: "#C6C6C6" }),
            _react2.default.createElement("path", { fill: "#333", d: "M8 4h12v2H8z" })
        )
    );
}; /*eslint-disable */


//////////////////
// WEBPACK FOOTER
// ./src/client/components/icons/small/jsx/element-column.js
// module id = 1860
// module chunks = 0